import type { ModelRegistry } from 'ember-data/types/registries/model';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';

export default class AlertRepositoryService extends BaseRepositoryService<
  ModelRegistry['alert']
> {
  recordName = 'alert';
  implementMethods = ['query', 'unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/alert': AlertRepositoryService;
  }
}
